import React from 'react';

const MangaPublication = ({ manga, formatDate }) => {
  return (
    <div className="manga-tab-content">
      <div className="manga-publication-info">
        <div className="manga-pub-section">
          <h4>Publication Details</h4>
          <div className="manga-pub-item">
            <span className="manga-label">Start Date</span>
            <span className="manga-value">{formatDate(manga.published?.from)}</span>
          </div>
          <div className="manga-pub-item">
            <span className="manga-label">End Date</span>
            <span className="manga-value">{formatDate(manga.published?.to) || 'Ongoing'}</span>
          </div>
          <div className="manga-pub-item">
            <span className="manga-label">Serialization</span>
            <span className="manga-value">
              {manga.serializations?.join(', ') || 'N/A'}
            </span>
          </div>
          <div className="manga-pub-item">
            <span className="manga-label">Volumes</span>
            <span className="manga-value">
              {manga.volumes || 'N/A'}
            </span>
          </div>
          <div className="manga-pub-item">
            <span className="manga-label">Chapters</span>
            <span className="manga-value">
              {manga.chapters || 'N/A'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MangaPublication;